<template>
    <div id="bar-chart">

      <div id="chart" v-if="dataReady">
        <apexchart 
          type=bar 
          height=350 
          :options="chartOptions" 
          :series="series" />
      </div>

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'bar-chart',
    props: ['optimalCosts','overSpending', 'average'],
    data: () => ({
        dataReady: false,
        series: [{
          name: 'Optimal Costs',
          data: null
        },
        {
          name: 'Over Spending',
          data: null
        }],
        chartOptions: {
          chart: {
            height: 350,
            type: 'bar',
            stacked: true,
            events: {
              click: function (chart, w, e) {
                console.log(chart, w, e)
              }
            },
          },
          colors: ["#008FFB", "#F00"],
          plotOptions: {
            bar: {
              columnWidth: '45%'
            }
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: ['Prevention', 'Appraisal', 'Internal Failure', 'External Failure', 'Other Types of Waste']
          },
          legend: {
            position: 'bottom',
            offsetY: -10
          },
          annotations: {
            yaxis: [
              {
                y: null,
                borderColor: "#00E396",
                label: {
                  borderColor: "#00E396",
                  style: {
                    color: "#fff",
                    background: "#00E396"
                  },
                  text: "Average Optimal Conditions"
                }
              }
            ]
          }
       }
    }),
    components: {
        apexchart: VueApexCharts,
    },
    created: function() {
        this.series[0].data = this.optimalCosts;
        this.series[1].data = this.overSpending;
        this.chartOptions.annotations.yaxis[0].y = this.average - (this.average * 0.15);

        this.dataReady = true;
    }
}
</script>
<style scoped>
</style>